import Chip from '@mui/material/Chip';
import type { ReactElement } from 'react';

/**
 * Payout rail badge (AUT-128) — DISPLAY-ONLY (architect guardrail #3).
 *
 * Renders `rail.toUpperCase()` as a brand-coloured chip ("oct" → "OCT").
 * `rail` is typed `string` on the wire for forward-compat: a future rail
 * added by DB migration (e.g. `mtbank_p2p` when AUT-91 unpauses) renders
 * as-is without a wire enum bump. This badge NEVER gates an action — the
 * Retry / Mark-manual buttons gate purely on the server-composed
 * `retryEligible` / `markManualEligible` flags.
 */
export const PayoutRailBadge = ({ rail }: { rail: string }): ReactElement => (
  <Chip size="small" color="primary" variant="outlined" label={rail.toUpperCase()} />
);
